import {VGSelect} from "vgselect";
import modifier from "./_modifier";

$(document).on('click', '[data-product-item] [data-to-product]', function () {
	let $item = $(this).closest('[data-product-item]');
	let id = $item.data('id');
	let params = {id: id};

	$.get('/catalog/modal_product', params, function (data) {
		let $modal = $("#modal-prd");
		$modal.find('#modal-prd-content').html(data.view);
		$modal.modal('show');

		let elements = document.querySelectorAll('.vg-select');
		for (const element of elements) {
			new VGSelect(element, {})
		}

		modifier()
	});

	return false;
});
